import { ACTION_TYPES } from "../constants/actionTypes";
import { arboristsLogin, generatePassCode,forgotPassword, fetchArboristProfile, editArboristProfile, arboristResetPassword, fetchAllArbors, addCompanyArborist, editCompanyArbor, deleteCompanyArbor} from "../API"
import { NotificationManager } from 'react-notifications';
import localStorage from "redux-persist/es/storage";

export const arboristAuth = (res, navigate)=> async(dispatch, getState)=>{
    try{
        dispatch({type:ACTION_TYPES.ARBORIST_LOGIN_REQUEST})
        localStorage.setItem("loginType",res.type)
        const {data} = await arboristsLogin(res)
        dispatch({type:ACTION_TYPES.ARBORIST_LOGIN_SUCCESS, payload: data.data})
        NotificationManager.success("Login Success")
        navigate("/arbor")
    }
    catch(err){
        console.log(err);
        dispatch({type:ACTION_TYPES.ARBORIST_LOGIN_FAILED})
        NotificationManager.error(err.response ? err.response.data.msg : err.message)
    }
}

export const generateCode = (res,Type)=> async(dispatch, getState)=>{
    try{
        localStorage.setItem("loginType",Type)
        dispatch({type: ACTION_TYPES.ARBORIST_GENERATECODE_REQUEST})
        const {data} = await generatePassCode(res)
        console.log(data)
        dispatch({type: ACTION_TYPES.ARBORIST_GENERATECODE_SUCCESS, payload:res})
        NotificationManager.success(data.msg ? data.msg : "password reset code has been sent to your email id! ")
    }
    catch(err){
        console.log(err);
        dispatch({type:ACTION_TYPES.ARBORIST_GENERATECODE_FAILED})
        NotificationManager.error(err.response ? err.response.data.msg : err.message ? err.message : "invalid data")
    }
}

export const forgotPass =(res)=>async(dispatch, getState)=>{
    try{
        dispatch({type: ACTION_TYPES.ARBORIST_FORGOTPASSWORD_REQUEST})
        const {data} = await forgotPassword(res)
        dispatch({type: ACTION_TYPES.ARBORIST_FORGOTPASSWORD_SUCCESS})
        localStorage.removeItem("loginType")
        NotificationManager.success(data.msg ? data.msg : "password reset successfully!")
    }
    catch(err){
        console.log(err);
        dispatch({type:ACTION_TYPES.ARBORIST_FORGOTPASSWORD_FAILED})
        NotificationManager.error(err?.response ? err?.response?.data?.msg : err.message)
    }
}

export const arboristLogout =()=>async(dispatch, getState)=>{
    try{
        dispatch({type: ACTION_TYPES.ARBORIST_LOGOUT_REQUEST})
        dispatch({type:ACTION_TYPES.ARBORIST_LOGOUT_SUCCESS, payload: {}})
    }
    catch(err){
        console.log(err.message);
        dispatch({type:ACTION_TYPES.ARBORIST_LOGOUT_FAILED})
        NotificationManager.error(err.response ? err.response.data.msg : err.message)
    }

}

export const getProfile =()=>async(dispatch, getState)=>{
    try{
        dispatch({type:ACTION_TYPES.FETCH_ARBOR_PROFILE_REQUEST})
        const { data } = await fetchArboristProfile()
        dispatch({type:ACTION_TYPES.FETCH_ARBOR_PROFILE_SUCCESS, payload:data.data})        
    }
    catch(err){
        console.log(err);
        dispatch({type:ACTION_TYPES.FETCH_ARBOR_PROFILE_FAILED})
        NotificationManager.error(err.response ? err.response.data.msg : err.message)
    }
}

export const editArborProfile =(res, navigate)=>async(dispatch, getState)=>{

    try{
        dispatch({type:ACTION_TYPES.EDIT_ARBOR_PROFILE_REQUEST})
        const {data} = await editArboristProfile(res)
        dispatch({type:ACTION_TYPES.EDIT_ARBOR_PROFILE_SUCCESS, payload: data.data})
        if(data.status === "success"){
            NotificationManager.success("Profile edit successfully")
            navigate("/arbor")           
        }
        dispatch(getProfile())
    }
    catch(err){
        console.log(err);
        dispatch({type:ACTION_TYPES.FETCH_ARBOR_PROFILE_FAILED})
        NotificationManager.error(err.response ? err.response.data.msg : err.message)
    }
}

export const resetPassword = (res, navigate)=>async(dispatch, getState)=>{
    try{
        dispatch({type:ACTION_TYPES.ARBORIST_RESETPASSWORD_REQUEST})
        const {data} = await arboristResetPassword(res)
        dispatch({type:ACTION_TYPES.ARBORIST_RESETPASSWORD_SUCCESS})
        NotificationManager.success(data.msg ? data.msg : "password reset successfully!")
        navigate("/arbor")
    }
    catch(err){
        console.log(err);
        dispatch({type:ACTION_TYPES.ARBORIST_RESETPASSWORD_FAILED})
        NotificationManager.error(err?.response ? err?.response?.data?.msg : err.message)
    }
}

export const fetchArbors =()=>async(dispatch, getState)=>{
    try{
        dispatch({type: ACTION_TYPES.FETCH_ARBOR_REQUEST})
        const {data} = await fetchAllArbors()
        dispatch({type: ACTION_TYPES.FETCH_ARBOR_SUCCESS, payload: data.data})
    }
    catch(err){
        console.log(err.message);
        dispatch({type:ACTION_TYPES.FETCH_ARBOR_FAILED})
        NotificationManager.error(err.response ? err.response.data.msg : err.message)
    }
}

export const addArbor =(res, navigate, location)=>async(dispatch)=>{
    try{
        dispatch({type: ACTION_TYPES.ADD_ARBOR_REQUEST})
        const {data} = await addCompanyArborist(res)
        dispatch({type: ACTION_TYPES.ADD_ARBOR_SUCCESS, payload: data.data})
        NotificationManager.success("Arbor added successfully")
        location?.state?.data === "/addArbor" ? navigate("/addArbor", {state:{data:data.data}}):
        location?.state?.data === "/editArbor" ? navigate("/editArbor", {state:{data:data.data}}) : 
        navigate("/arborManager")       
    }
    catch(err){
        console.log(err);
        dispatch({type:ACTION_TYPES.ADD_ARBOR_FAILED})
        NotificationManager.error(err.response ? err.response.data.error : err.message)
    }
}

export const setArbor =(res)=>async(dispatch, getState)=>{
    try{
        dispatch({type: ACTION_TYPES.SET_ARBOR_REQUEST})
        console.log(res)
        dispatch({type: ACTION_TYPES.SET_ARBOR_SUCCESS, payload:res})
    }
    catch(err){
        console.log(err.message);
        dispatch({type:ACTION_TYPES.SET_ARBOR_FAILED})
        NotificationManager.error(err.message)
    }
}

export const editArborData = (res, navigate) =>async(dispatch, getState)=>{
    try{
        dispatch({type: ACTION_TYPES.EDIT_ARBOR_REQUEST})
        const { arbor } = getState().arbor
        const { data } = editCompanyArbor(arbor._id,res)
        dispatch({type:ACTION_TYPES.EDIT_ARBOR_SUCCESS})
        NotificationManager.success("Arbor edit successfully")
        navigate("/arborManager")
    }
    catch(err){
        console.log(err.message);
        dispatch({type:ACTION_TYPES.EDIT_ARBOR_FAILED})
        NotificationManager.error(err.message)
    }
}

export const deleteArborId =(row) =>async(dispatch, getState)=>{
    try{
        dispatch({type: ACTION_TYPES.DELETE_ARBOR_REQUEST})
        const {data} = deleteCompanyArbor(row)
        dispatch({type: ACTION_TYPES.DELETE_ARBOR_SUCCESS})
        NotificationManager.success("Arbor delete successfully")
        dispatch(fetchArbors())
    }
    catch(err){
        console.log(err.message);
        dispatch({type:ACTION_TYPES.DELETE_ARBOR_FAILED})
        NotificationManager.error(err.message)
    }
}